/**
 * Das Belegdetail der Rechnungsseite (`InvoiceDetailDrawer`) an der Projektseite:
 * Dokument, Status, Versand, Folgebelege und „… ändern" in den Editor — dieselbe
 * Vorstufe wie unter „Rechnungen & Angebote" (Benjamin, 02.10.2026: nicht nur
 * ansehen, sondern von hier aus bearbeiten). Kunden und Projekte lädt es erst,
 * wenn es offen ist.
 */
import InvoiceDetailDrawer from "../invoices/InvoiceDetailDrawer";
import { useKunden, useProjekte } from "../../hooks/usePlanung";
import type { InvoiceRegisterItem } from "../../lib/invoices";

type Props = { beleg: InvoiceRegisterItem; onClose: () => void; onUpdated: (b: InvoiceRegisterItem) => void };

export default function BelegBlatt({ beleg, onClose, onUpdated }: Props) {
  const { data: customers = [] } = useKunden();
  const { data: projects = [] } = useProjekte(true);
  return <InvoiceDetailDrawer item={beleg} customers={customers} projects={projects} onClose={onClose} onUpdated={onUpdated} />;
}
